import { render, staticRenderFns } from "./safetyOrgMst.vue?vue&type=template&id=1869c166"
import script from "./safetyOrgMst.vue?vue&type=script&lang=js"
export * from "./safetyOrgMst.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1869c166')) {
      api.createRecord('1869c166', component.options)
    } else {
      api.reload('1869c166', component.options)
    }
    module.hot.accept("./safetyOrgMst.vue?vue&type=template&id=1869c166", function () {
      api.rerender('1869c166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/org/safetyOrgMst.vue"
export default component.exports